export default __webpack_public_path__ + "static/media/do-1@2x.dc06f6d4.jpg";